// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"447":"FullProductInfo","775":"Novinki"}[chunkId] + "." + {"447":"4de12cb7","775":"0757cbb4"}[chunkId] + ".chunk.js";
};